import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IMeetingTypesService } from "services/MeetingTypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  MeetingTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const meetingTypeSelectSlice = createSlice({
  name: "meetingTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMeetingTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getMeetingTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getMeetingTypeSelectModels.fulfilled, (state, action) => {
        state.MeetingTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getMeetingTypeSelectModels = createAsyncThunk("MeetingTypeSelect/GetSelectModels", async () => {
  const meetingTypesService = container.get<IMeetingTypesService>(SERVICE_TYPES.MeetingTypesService);
  return await meetingTypesService.getMeetingTypeSelectModels();
});

export const selectMeetingTypeSelectModels = (state: RootState) => {
  return state.meetingTypesSelect.MeetingTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.meetingTypesSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.meetingTypesSelect.LastUpdateTime;
};

export default meetingTypeSelectSlice.reducer;
